// Gallery: images that didn't earn an inline slot in the article (not enough
// prose between them). Shown as a grid at the bottom of the page.
import React from 'react';

export default function ProjectGallery({ images, onOpenImage, title = 'Gallery' }) {
  if (!images || images.length === 0) return null;

  return (
    <section className="pd-gallery">
      <h2 className="pd-section-title">{title}</h2>
      <div className="pd-gallery__grid">
        {images.map((image) => (
          <button
            key={image.index}
            type="button"
            className="pd-gallery__item"
            onClick={() => onOpenImage(image)}
          >
            <img
              src={image.thumbnailSrc || image.src}
              alt={image.caption || ''}
              loading="lazy"
              decoding="async"
              className="pd-gallery__img"
            />
            {image.caption && <span className="pd-gallery__caption">{image.caption}</span>}
          </button>
        ))}
      </div>
    </section>
  );
}
